import { useMemo } from 'react'
import { observer } from 'mobx-react'
import { isEmpty } from 'lodash'

// import { DefaultLendPrice } from '@/config/constants/assets'
import { useAppState } from '@/stores'
import {
  numberFormat,
  formatBIUnit
  // hexToDecimalAmount
} from '@/utils/format'
// import { useFeesDailySnapshotsAndMarketsData } from '@/utils/dataHooks'
// import { decimalsETH } from '@/config/constants/networks'

import SubHeaderMarkets from '@/views/Home/components/TopHomePage/SubHeaderMarkets'

// import { GetFeesDailySnapshotsAndMarketsQuery } from '~/.graphclient'

type SunHeaderItemValueType = {
  title: string
  value: any
}
type SunHeaderItemsType = Record<string, SunHeaderItemValueType>

const headerDataInit: SunHeaderItemsType = {
  totalValue: { title: 'Total Value Locked', value: '' },
  totalLoan: { title: 'Total Loan Originations', value: '' },
  currentLoans: { title: 'Current Loans Outstanding', value: '' },
  // lendPrice: { title: 'LEND Price', value: '' },
  // lendMarketCap: { title: 'LEND Market Cap', value: '' },
  // supply: { title: 'LEND Circulating Supply', value: '' },
  healthFactor: { title: 'Global Health factor', value: '' }
}

function TopHomePage() {
  const {
    walletAccountStore: { projectTokenPrice, multiFeeDistribution, MFDBalance, reserves }
  } = useAppState()
  // const feesAndMarketsData = useFeesDailySnapshotsAndMarketsData(1) || ({} as GetFeesDailySnapshotsAndMarketsQuery)
  // const { markets, financialsDailySnapshots } = feesAndMarketsData

  const totalSupply = useMemo(
    () =>
      !isEmpty(reserves)
        ? Object.values(reserves).reduce(
            (acc: number, reserve: any) =>
              reserve.supplied.amount
                ? acc + formatBIUnit(reserve.supplied.amount, reserve.decimals) * reserve.price
                : acc,
            0
          )
        : 0,
    [reserves]
  )
  const totalBorrow = useMemo(
    () =>
      !isEmpty(reserves)
        ? Object.values(reserves).reduce(
            (acc: number, reserve: any) =>
              reserve.borrowed.amount
                ? acc + formatBIUnit(reserve.borrowed.amount, reserve.decimals) * reserve.price
                : acc,
            0
          )
        : 0,
    [reserves]
  )

  const subHeaderData = useMemo(() => {
    headerDataInit.totalValue.value = totalSupply ? `$${numberFormat(totalSupply)}` : ''
    headerDataInit.currentLoans.value = totalBorrow ? `$${numberFormat(totalBorrow)}` : ''
    headerDataInit.healthFactor.value = totalBorrow ? numberFormat(totalSupply / totalBorrow) : 0
    // const priceLend = projectTokenPrice || DefaultLendPrice
    // const lendTotalStaked =
    //   multiFeeDistribution.lockedSupply && MFDBalance
    //     ? hexToDecimalAmount(String(MFDBalance)) -
    //       formatBIUnit(multiFeeDistribution.lockedSupply)
    //     : 0
    // const lendTotalSupply = MFDBalance ? hexToDecimalAmount(String(MFDBalance)) : 0
    // const lendCirculatingSupply = lendTotalStaked || null
    // headerDataInit.totalLoan.value = financialsDailySnapshots?.length
    //   ? `$${numberFormat(financialsDailySnapshots[0].cumulativeBorrowUSD)}`
    //   : ''
    // headerDataInit.lendPrice.value = markets?.length ? `$ ${numberFormat(projectTokenPrice, { maxDigits: 4 })} ` : ''
    // headerDataInit.lendMarketCap.value =
    // priceLend && lendTotalSupply ? `$ ${numberFormat(lendTotalSupply * Number(priceLend))}` : ''
    // headerDataInit.supply.value = lendCirculatingSupply ? `${numberFormat(lendCirculatingSupply)}` : ''

    return Object.values(headerDataInit)
  }, [totalSupply, totalBorrow])

  return <SubHeaderMarkets subHeaderDataArr={subHeaderData} />
}

export default observer(TopHomePage)
